module.exports = __webpack_public_path__ + "static/media/fuel.7d067021.PNG";